module.exports = __webpack_public_path__ + "img/TESL-everyone-has-a-price.24a79ea4.jpg";